import './detailed_itinerary_object.scss';
